const { JOB_STATUS } = require("~/constants/jobs");

export const getLabelForStatus = (status) => {
  const item = JOB_STATUS.find((i, x) => i.value === status);
  return item || { value: "", label: "-", color: "black" };
};
